import React from 'react';
import Footer from './footer/FooterIndex';
import { MdSubscriptions, MdGames } from "react-icons/md";
import { BsNewspaper } from "react-icons/bs";
import { GiCook } from "react-icons/gi";
import Logo from "../Utils/title.jpg";

export function FooterContainer() {
  return (
    <Footer style={{ paddingTop: '50px' }}>
      <Footer.Wrapper>
        <Footer.Row>
          <Footer.LogoContainer>
            <img src={Logo} alt="The Juba Times logo" />
          </Footer.LogoContainer>
        </Footer.Row>
        
        <Footer.Row>
          <Footer.Column>
            <Footer.Title>News</Footer.Title>
            <Footer.Links to="#">Home Page</Footer.Links>
            <Footer.Links to="#">Africa</Footer.Links>
            <Footer.Links to="#">World</Footer.Links>
            <Footer.Links to="#">Politics</Footer.Links>
            <Footer.Links to="#">Juba</Footer.Links>
            <Footer.Links to="#">Business</Footer.Links>
            <Footer.Links to="#">Tech</Footer.Links>
            <Footer.Links to="#">Science</Footer.Links>
            <Footer.Links to="#">Sport</Footer.Links>
          </Footer.Column>
          
          <Footer.Column>
            <Footer.Title>Opinion</Footer.Title>
            <Footer.Links to="#">Today's Opinion</Footer.Links>
            <Footer.Links to="#">Op-Ed Columnists</Footer.Links>
            <Footer.Links to="#">Editorials</Footer.Links>
            <Footer.Links to="#">Op-Ed Contributors</Footer.Links>
            <Footer.Links to="#">Letters</Footer.Links>
            <Footer.Links to="#">Sunday Review</Footer.Links>
            <Footer.Links to="#">Video: Opinion</Footer.Links>
          </Footer.Column>
          
          <Footer.Column>
            <Footer.Title>Arts</Footer.Title>
            <Footer.Links to="#">Today's Arts</Footer.Links>
            <Footer.Links to="#">Art & Design</Footer.Links>
            <Footer.Links to="#">Books</Footer.Links>
            <Footer.Links to="#">Dance</Footer.Links>
            <Footer.Links to="#">Movies</Footer.Links>
            <Footer.Links to="#">Music</Footer.Links>
            <Footer.Links to="#">Pop Culture</Footer.Links>
            <Footer.Links to="#">Television</Footer.Links>
          </Footer.Column>
          
          <Footer.Column>
            <Footer.Title>Living</Footer.Title>
            <Footer.Links to="#">At Home</Footer.Links>
            <Footer.Links to="#">Automobiles</Footer.Links>
            <Footer.Links to="#">Games</Footer.Links>
            <Footer.Links to="#">Education</Footer.Links>
            <Footer.Links to="#">Food</Footer.Links>
            <Footer.Links to="#">Health</Footer.Links>
            <Footer.Links to="#">JubaTimesMagazine</Footer.Links>
            <Footer.Links to="#">Real Estate</Footer.Links>
          </Footer.Column>
          
          <Footer.Column>
            <Footer.Title>More</Footer.Title>
            <Footer.Links to="#">Reader Center</Footer.Links>
            <Footer.Links to="#">Live Events</Footer.Links>
            <Footer.Links to="#">The Learning Network</Footer.Links>
            <Footer.Links to="#">Tools and Services</Footer.Links>
            <Footer.Links to="#">Multimedia Photography</Footer.Links>
            <Footer.Links to="#">Video</Footer.Links>
            <Footer.Links to="#">Newsletter</Footer.Links>
            <Footer.Links to="#">Manage My Account</Footer.Links>
            <Footer.Links to="#">Job Advertisment</Footer.Links>
          </Footer.Column>
          
          <Footer.SubscribeColumn>
            <Footer.Title>Subscribe</Footer.Title>
            
            <Footer.Link2 href="#">
              <h3>
                <Footer.IconWrapper><BsNewspaper /></Footer.IconWrapper>
                Home Delivery
              </h3>
            </Footer.Link2>
            
            <Footer.Link2 href="#">
              <h3>
                <Footer.IconWrapper><MdSubscriptions /></Footer.IconWrapper>
                Digital Subscriptions
              </h3>
            </Footer.Link2>
            
            <Footer.Link2 href="#">
              <h3>
                <Footer.IconWrapper><MdGames /></Footer.IconWrapper>
                Games
              </h3>
            </Footer.Link2>
            
            <Footer.Link2 href="#">
              <h3>
                <Footer.IconWrapper><GiCook /></Footer.IconWrapper>
                Music
              </h3>
            </Footer.Link2>
            
            <Footer.List>
              <li>Email Newsletters</li>
              <li>Corporate Subscriptions</li>
              <li>Education</li>
            </Footer.List>
          </Footer.SubscribeColumn>
        </Footer.Row>
        
        <Footer.FooterBottom>
          <span>&copy; 2025 The Juba Times Company</span>
          <span>&copy; Developed by GraBit Technologies</span>
          <span>JubaTimes Co</span>
          <span>Contact Us</span>
          <span>Work with us</span>
          <span>Advertisers</span>
          <span>Privacy Policy</span>
          <span>Terms of Service</span>
          <span>Help</span>
        </Footer.FooterBottom>
      </Footer.Wrapper>
    </Footer>
  );
}